import { Table } from '@octano/global-ui';
import { PaymentInfo } from '../../../../../types';
import { usePaymentStatusColumns } from './usePaymentStatusColumns';

type Props = {
  data: PaymentInfo;
  texts: {
    title: string;
    table: {
      noResults: string;
      headers: {
        concept: string;
        amount: string;
        paymentDate: string;
        status: string;
        action: string;
      };
      values: {
        concept: string;
        button: string;
        payment: {
          pending: string;
          paid: string;
        };
      };
    };
  };
};

export function PaymentStatus({ data, texts }: Props) {
  const columns = usePaymentStatusColumns(texts.table);
  const tableData = data ? [data] : [];
  return (
    <>
      <p className="fs-20 text-uppercase text-primary fw-700 mb-0">
        {texts.title}
      </p>
      <Table
        columns={columns}
        data={tableData}
        noResultsText={texts.table.noResults}
      />
    </>
  );
}
